import { useMyTimeTrackingSettings } from './useMyTimeTrackingSettings';

export const useHideTimeTrackingControls = (): boolean => {
  const { data, loading } = useMyTimeTrackingSettings();

  if (!data) {
    return loading;
  }

  if (data.me.workloads.length < 1) {
    return false;
  }

  const timeFramework = data.me.workloads[0].timeFramework;
  return timeFramework?.flair__Hide_Time_Tracking_Controls_in_Hub__c ?? false;
};
